export function getEmailDomain(email: string): string | undefined {
  return email.split("@")[1] || undefined;
}

export function getMailHost(email: string, fallback = "mail.yourdomain.com"): string {
  const domain = getEmailDomain(email);
  return domain ? `mail.${domain}` : fallback;
}

export function getWebmailHost(email: string, fallback = "webmail.siteoplossing.nl"): string {
  const domain = getEmailDomain(email);
  return domain ? `webmail.${domain}` : fallback;
}
